// extracted by mini-css-extract-plugin
export default {"tooltipContent":"FlatRatePriceTooltip_tooltipContent__XIygn"};